import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { ProjectService } from "../../../core/services/project/project.service";
import { RestService } from "../../../core/services/rest.service";
import { SideNavService } from "../../../core/services/side-nav/side-nav.service";
import { ToasterService } from "../../../core/services/toaster-service";
import { MaterialModule } from "../../../core/shared/material.module";
import { MessageEnum } from "../../../core/utils/message.enum";
import { SharedComponents } from "../../shared.module";

@Component({
  selector: "app-project-configuration",
  standalone: true,
  imports: [CommonModule, MaterialModule, ...SharedComponents, NzSwitchModule],
  templateUrl: "./project-configuration.component.html",
  styleUrl: "./project-configuration.component.scss",
})
export class ProjectConfigurationComponent {
  activeModal = inject(NgbActiveModal);
  @Input() data: any = "";
  loading: boolean = false;
  survey: any = {};
  isActive : boolean = false;
  
    @BlockUI()
    blockUI!: NgBlockUI;

  /**
   * Initializes the component with required services and sets the route parameter map.
   * @param {RestService} restService - Service for API interactions.
   * @param {Router} router - Provides navigation functionality.
   * @param {ActivatedRoute} route - Provides information about the route.
   * @param {SideNavService} sideNav - Manages the side navigation state.
   */
  constructor(
    public restService: RestService,
    public router: Router,
    private route: ActivatedRoute,
    private sideNav: SideNavService,
    private projectService: ProjectService,
    private readonly toaster: ToasterService
  ) {

  }

  ngOnInit() {
    this.loading = true;
    this.restService.getSurveySubmission(this.data).subscribe(
      (questions) => {
        this.survey = questions?.data;
        if (this.survey?.answers) {
          this.survey.answers = this.survey.answers
            .slice()
            .sort((a: { questionText: string }, b: { questionText: any }) =>
              a.questionText.localeCompare(b.questionText)
            );
        }
        this.loading = false;
      },
      (error) => {
        this.toaster.pop({ type: 'error', text: MessageEnum.SURVEY_DETAILS_FAILURE });
      }
    );
  }

  /**
   * Submits the survey details and navigates to the associated project page.
   * Displays success or error messages based on the API response.
   */
  submitSurvey() {

    console.log(this.survey);
        this.blockUI.start("Saving...");
    this.restService.surveySubmission(this.survey).subscribe(
      (item) => {
        console.log(item);
        this.projectService.setProjectOverview(item);
        this.blockUI.stop();
        this.activeModal.dismiss();
        this.toaster.pop({ type: 'success', text: MessageEnum.SURVEY_SUBMIT_SUCCESS });
        this.sideNav.setTreeNode("manageApplication");
      },
      (error) => {
        this.blockUI.stop();
        this.activeModal.dismiss();
        this.toaster.pop({ type: 'error', text: MessageEnum.SURVEY_SUBMIT_FAILURE });
      }
    );
  }
}
